import { useQuery } from "react-query";
import { getBusinessLicensePermitLicenseStatusOptions } from "../../../../actions/CarrierAgreementMgmt/BusinessLicensesAndPermits";
 
export const useGetBusLicensePermitLicenseStatusOptions = () => {
  return useQuery(
    "GetBusinessLicensePermitLicenseStatusOptions",
    getBusinessLicensePermitLicenseStatusOptions,
    { refetchOnWindowFocus: false }
  );
};